import { tv } from "tailwind-variants";

export const field = tv({
  base: [
    "[--field-bg:var(--color-ds-surface-2)]",
    "[--field-bg-focus:var(--color-ds-surface-foundation)]",
    "[--field-bg-disabled:var(--field-bg)]/50",
    "dark:[--field-bg-disabled:var(--field-bg)]/24",

    "[--field-border:var(--color-ds-stroke-primary)]",
    "[--field-border-focus:var(--color-ds-stroke-tertiary)]",
    "[--field-border-error:var(--color-ds-stroke-error)]",
    "[--field-border-disabled:var(--color-ds-stroke-disabled)]",

    "[--field-ring:var(--color-ds-neutral-6)]",
    "[--field-ring-error:var(--color-ds-red-6)]",

    "[--field-text:var(--color-ds-text-primary)]",
    "[--field-text-placeholder:var(--color-ds-text-placeholder)]",
    "[--field-text-disabled:var(--color-ds-text-disabled)]",
  ],
});
